import React, { ReactFragment } from "react"
import styled from "styled-components"
import AcIcon from "~/components/atoms/AcIcon"
import IconWarning from "~/components/template/IconWarning"

export namespace Icon {
  export const Check = styled(({ ...rest }) => <AcIcon {...rest} name={"check"} />)`
    .fa-check {
      border: 5px solid #11bc4c;
      border-radius: 50%;
      color: #11bc4c;
      padding: 12%;
    }
  `

  export const Exclamation = styled(({ ...rest }) => <AcIcon {...rest} name={"exclamation"} />)`
    .fa-exclamation {
      border: 5px solid #ef1f1f;
      border-radius: 50%;
      color: #ef1f1f;
      padding: 12%;
    }
  `
}
